import React, {useEffect} from "react"
import { Background } from "./Background/Background"
import { Background2 } from "./Background/Background2"
import { BackgroundSection } from './Background/BackgroundSection'
import { Equipe } from "./Equipe/Equipe"
import { Header } from "./Header"
import Banner from "./ui/Banner"

import { SvgCare } from './icons/care'
import { SvgQuality2 } from './icons/quality2'
import { FaRegHeart } from "react-icons/fa";
import { RiSurroundSoundLine } from "react-icons/ri";
import Title from "./ui/Title"
import { WidthContainer } from "./WidthContainer"
import Faq from "./ui/Faq"
import { Hero } from "./ui/Hero"
import { ButtonStore } from "./ui/ButtonStore"
import ResultsWrapper from "./sections/ResultsWrapper"
import ThemeWrapper from "./sections/ThemesWrapper"
import TestimonialsWrapper from "./sections/TestimonialsWrapper"
import OffersWrapper from "./sections/OffersWrapper"
import Footer from "./ui/Footer"
import firebase from "gatsby-plugin-firebase"
import { ANALYTIC_EVENT_NAMES } from "../constants/analytics"


const Home = ({ location }) => {

    // analytics - page viewed event
    useEffect(() => {
        if(!firebase) {
            return;
        }
        firebase.analytics().logEvent(ANALYTIC_EVENT_NAMES.web_page_viewed)
        firebase.analytics().logEvent(ANALYTIC_EVENT_NAMES.web_home_page_viewed)
    }, [firebase])

    return (
        <div id="background"
            {...{
                style: {
                    placeItems: "center",
                    background: "#102543",
                    height: "100%",
                    color: "#102543"
                },
            }}>

            <Header {...{ location }} />
            <Hero
            title="Votre bien-être par l’hypnose"
            subtitle="Notre application a été conçue pour vous aider à améliorer votre santé et votre bien-être rapidement et naturellement"
            img="/images/hero/poster1.webp"
            showcaseImg="/images/hero/appscreenshots.webp"
            video="/images/hero/14-900-crf16-veryslow-pixfmtyuv420.mp4"
            >
                <ButtonStore variant="apple"/>
                <ButtonStore variant="playstore"/>
            </Hero>
            <Background>
                <WidthContainer center>
                    <div className="w-full md:w-4/5">
                        <Title addStyle="w-full md:w-4/5 mt-16 mb-8" variant="md">Profitez des bienfaits de l’hypnose pour aller mieux naturellement et rapidement.</Title>
                        <Faq
                            items={[
                                {
                                    title:"L'hypnose c’est quoi ?",
                                    desc:"L’hypnose se définit comme un état modifié de conscience totalement naturel. L’hypnose est très utilisée aujourd’hui dans le monde médical comme par exemple dans le traitement de la douleur. Il existe aussi d’autres champs d’application de l’hypnose dans le domaine du bien-être comme l’amélioration du sommeil, la réduction du stress et de l’anxiété, etc."
                                }
                            ]}
                        />
                    </div>
                </WidthContainer>
                <Banner
                    title="Des séances d’hypnose thérapeutique au service de votre bien-être"
                    ctaAnchor="Je teste l'expérience Happiz"
                    ctaAction="https://happiz.onelink.me/5ePS/e6b33nm1"
                    img="/images/benefits/b1.webp"
                    ctaIcon={<FaRegHeart/>}
                >
                    <p>
                        Il existe de nombreuses formes d’application de l’hypnose.
                        Happiz vous propose des séances d’hypnose dédiées à l’évolution de votre bien-être.
                    </p>
                </Banner>
                <Banner
                    title="Des séances d’hypnose de haute qualité"
                    ctaAnchor="Je teste l'expérience Happiz"
                    ctaAction="https://happiz.onelink.me/5ePS/e6b33nm1"
                    img="/images/benefits/b2.webp"
                    ctaIcon={<SvgQuality2 />}
                    isReverse
                >
                    <p>
                        Toutes nos séances d’hypnose sont conçues par des professionnels de l’hypnose certifiés. De plus, nous travaillons avec des experts de l’accompagnement (psychothérapeutes, sophrologues, nutritionnistes,…) pour créer des contenus pertinents. Tous nos contenus sont produits en France et adoptent une approche éthique et déontologique de l’hypnose.
                    </p>
                </Banner>
                <Banner
                    title="Des séances avec un son spatialisée comme au cinéma"
                    ctaAnchor="Je teste l'expérience Happiz"
                    ctaAction="https://happiz.onelink.me/5ePS/e6b33nm1"
                    img="/images/benefits/surround.webp"
                    ctaIcon={<RiSurroundSoundLine />}
                >
                    <p>
                        Placez vos écouteurs pour profiter de l’expérience sonore Happiz avec une technologie sonore spatialisée digne d’une salle de cinéma. Le son semble provenir de toutes les directions pour rendre nos expériences encore plus immersives et donc hypnotiques.
                    </p>
                </Banner>
                <Banner
                    title="Des expériences d’hypnose en toute sécurité"
                    ctaAnchor="Je teste l'expérience Happiz"
                    ctaAction="https://happiz.onelink.me/5ePS/e6b33nm1"
                    img="/images/benefits/b3.webp"
                    ctaIcon={<SvgCare />}
                    isReverse
                >
                    <p>
                        Votre sécurité est l’une de nos priorités.
                        C’est pourquoi chez Happiz, toutes nos séances d’hypnose ont été réalisées spécifiquement pour que vous gardiez le contrôle de ce qu’il se passe ainsi qu’un niveau de conscience adapté.
                        De plus, nos séances se terminent toutes par une phase de réveil en douceur pour vous permettre de continuer votre journée sereinement.
                    </p>
                </Banner>

                <BackgroundSection bottomBenefits>
                    <Banner
                        title="Des programmes personnalisés pour vous guider"
                        ctaAnchor="Je teste l'expérience Happiz"
                        ctaAction="https://happiz.onelink.me/5ePS/e6b33nm1"
                        img="/images/benefits/appComplete.webp"
                        ctaIcon={<SvgCare />}
                        isReverse
                    >
                        <p>
                            Nous vous proposons des programmes personnalisés en fonction de vos problématiques pour vous guider facilement dans l’évolution de votre bien-être (stress, sommeil, addiction, phobie…).
                            Nos programmes vous permettent également d’avoir un suivi mesuré pour vous aider à y voir plus clair.
                        </p>
                        <Title variant="md">Une application complète</Title>
                        <p className="mt-6">
                            Nous vous proposons des programmes personnalisés en fonction de vos problématiques pour vous guider facilement dans l’évolution de votre bien-être (stress, sommeil, addiction, phobie…).
                            Nos programmes vous permettent également d’avoir un suivi mesuré pour vous aider à y voir plus clair.
                        </p>
                    </Banner>
                </BackgroundSection>
                {/* <Benefits /> */}
            </Background>
            <Background2>
                <ResultsWrapper/>
                <BackgroundSection themeTemoignages>
                    {/* <ThemeWrapper /> */}
                    <TestimonialsWrapper/>
                </BackgroundSection>
                <BackgroundSection equipe>
                    <Equipe />
                </BackgroundSection>
            </Background2>
            {/* <BackgroundSection footer> */}
            <Footer/>
            {/* </BackgroundSection> */}
        </div>
    )
}

export { Home }
